import classNames from 'clsx';
import React, { type ChangeEvent, memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { NestleFormWrapperContext } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.context';

import styles from '../CardForm.css';

interface InputFieldProps {
    name: string;
    placeholder: string;
    type?: string;
}

export const InputField = memo<InputFieldProps>(({ name, placeholder, type = 'text' }) => {
    const { formData, formErrors, setFormData, setFormErrors } = useContext(NestleFormWrapperContext);
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        if (formErrors[name]) {
            setFormErrors((prev) => ({ ...prev, [name]: false }));
        }
    };

    return (
        <input
            type={type}
            name={name}
            placeholder={placeholder}
            value={formData[name]}
            onChange={handleChange}
            className={classNames(styles.formInput, {
                [styles.validateError]: formErrors[name],
                [styles.formInputPhone]: isMobile,
                [styles.validateErrorPhone]: formErrors[name] && isMobile,
            })}
        />
    );
});

InputField.displayName = 'InputField';
